import { Download } from "@mui/icons-material";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { useCallback, useState } from "react";
import { toast } from "sonner";

import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { downloadInvoicePdf } from "Invoices/Utils/downloadInvoicePdf";

interface InvoiceDownloadIconButtonProps {
  invoiceID: string;
}

export const InvoiceDownloadIconButton = ({
  invoiceID,
}: InvoiceDownloadIconButtonProps): React.ReactNode => {
  const { t } = useResource();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = useCallback(async () => {
    setIsDownloading(true);
    try {
      await downloadInvoicePdf(invoiceID);
    } catch {
      toast.error(t(Resources.Invoices.DownloadError));
    } finally {
      setIsDownloading(false);
    }
  }, [invoiceID, t]);

  return (
    <Tooltip title={t(Resources.Invoices.DownloadInvoice)}>
      <IconButton
        size="small"
        onClick={handleDownload}
        disabled={isDownloading}
      >
        {isDownloading ? (
          <CircularProgress size={18} />
        ) : (
          <Download fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
};
